export default "__VITE_ASSET__DUOQuNcd__"